export const mainCont = {
  width: "100vw",
  height: "100vh",
  border: "1px solid red",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};
